import { createFileRoute } from '@tanstack/react-router';

import { Layout } from './-components/Layout';
import { teamListSearchParams } from './-components/teamListSearchParams';

export const Route = createFileRoute('/_authenticated/teams')({
    validateSearch: teamListSearchParams,
    component: Layout,
});
